import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { OperationDTO } from './dto/operations.dto';
import { OperationRequest } from './dto/operations.request';
import { OperationsService } from './operations.service';
import { OperationResponseModel,AllOperationsResponseModel, VarientIdRequest, OperationsDropDownResponse, OperationandLotReq, operationReq, LotAndSaleOrderIdReq } from '@gtpl/shared-models/production-management';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';

@ApiTags('Operations')
@Controller('operations')
export class OperationsController {
    constructor(
        private operationsService: OperationsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }

    /**
     * 
     * @param OperationDTO 
     * @param isUpdate 
     * @returns OperationResponseModel
     */
    @Post('/createOperation')
    async createOperation(@Body() operationDTO: OperationDTO, isUpdate: boolean = false): Promise<OperationResponseModel> {
        try {
            return await this.operationsService.createOperation(operationDTO, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(OperationResponseModel, error)
        }
    }
    /**
     * 
     * @param operationDTO 
     * @returns OperationResponseModel
     */
    @Post('/updateOperation')
    async updateOperation(@Body() operationDTO: OperationDTO): Promise<OperationResponseModel> {
        try {
            return await this.operationsService.createOperation(operationDTO, true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(OperationResponseModel, error)
        }
    }
    /**
     * 
     * @param request 
     * @returns AllOperationsResponseModel
     */
    @Post('/getAllOperations')
    async getAllOperations(@Body() inputReq: VarientIdRequest): Promise<AllOperationsResponseModel> {
        try {
            return await this.operationsService.getAllOperations(inputReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllOperationsResponseModel, error)
        }
    }
    /**
     * 
     * @param operationReq OperationRequest
     * @returns OperationResponseModel
     */
    @Post('/activateOrDeactivateOperation')
    async activateOrDeactivateOperation(@Body() operationReq: OperationRequest): Promise<OperationResponseModel> {
        try {
            return await this.operationsService.activateOrDeactivateOperation(operationReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(OperationResponseModel, err);
        }
    }

    @Post('/getAllOperationsDropDown')
    async getAllOperationsDropDown(): Promise<OperationsDropDownResponse> {
        try {
            return await this.operationsService.getAllOperationsDropDown();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(OperationsDropDownResponse, err);
        }
    }
    @Post('/GetAllLotInformationAginstOperationandlot')
    async GetAllLotInformationAginstOperationandlot(@Body() req:OperationandLotReq): Promise<CommonResponse> {
        try {
            return await this.operationsService.GetAllLotInformationAginstOperationandlot(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getLotNumbersDropDownForLotClub')
    async getLotNumbersDropDownForLotClub(@Body() req:operationReq): Promise<CommonResponse> {
        try {
            return await this.operationsService.getLotNumbersDropDownForLotClub(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getProductionUsage')
    async getProductionUsage(): Promise<CommonResponse> {
        try {
            return await this.operationsService.getProductionUsage();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getLotNumbersDropDownForRejections')
    async getLotNumbersDropDownForRejections(@Body() req:PlantIdRequest): Promise<CommonResponse> {
        try {
            return await this.operationsService.getLotNumbersDropDownForRejections(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAllOperationsAgainistlotAndsoId')
    async getAllOperationsAgainistlotAndsoId(@Body() req:LotAndSaleOrderIdReq): Promise<CommonResponse> {
        try {
            return await this.operationsService.getAllOperationsAgainistlotAndsoId(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
}


